import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-refund',
  templateUrl: './confirm-refund.component.html',
  styleUrls: ['./confirm-refund.component.scss']
})
export class ConfirmRefundComponent implements OnInit {
  
  @ViewChild('content') content!: ElementRef;
  
  @Input() cancelBookingIds: number[] = [];
  @Output() onConfirmRefund = new EventEmitter<any>();

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  open() {
    this.modalService.open(this.content);
  }

  onConfirm(modal: any, refund: boolean) {
    modal.close('Close selecion');
    this.onConfirmRefund.emit(this.cancelBookingIds.map(bookingId => ({
      refund,
      bookingId,
    })));
  }

}
